import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000, // 5 minut
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
